export default "__VITE_ASSET__CH6Gt2Lz__"